export default __webpack_public_path__ + "static/sns-c754a7e5ce5d5f68e95c90a1de329f0c.svg";